/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuleSetCustomizationSyncDto
 */
export interface RuleSetCustomizationSyncDto {
    /**
     * 
     * @type {string}
     * @memberof RuleSetCustomizationSyncDto
     */
    scope: RuleSetCustomizationSyncDtoScopeEnum;
}


/**
 * @export
 */
export const RuleSetCustomizationSyncDtoScopeEnum = {
    Full: 'FULL',
    Active: 'ACTIVE',
    Passive: 'PASSIVE'
} as const;
export type RuleSetCustomizationSyncDtoScopeEnum = typeof RuleSetCustomizationSyncDtoScopeEnum[keyof typeof RuleSetCustomizationSyncDtoScopeEnum];


/**
 * Check if a given object implements the RuleSetCustomizationSyncDto interface.
 */
export function instanceOfRuleSetCustomizationSyncDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "scope" in value;

    return isInstance;
}

export function RuleSetCustomizationSyncDtoFromJSON(json: any): RuleSetCustomizationSyncDto {
    return RuleSetCustomizationSyncDtoFromJSONTyped(json, false);
}

export function RuleSetCustomizationSyncDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleSetCustomizationSyncDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'scope': json['scope'],
    };
}

export function RuleSetCustomizationSyncDtoToJSON(value?: RuleSetCustomizationSyncDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'scope': value.scope,
    };
}

